import { useNavigate, useLocation } from 'react-router-dom';
import { useOrdersContext } from '@/contexts/OrderContext';
import NotificationBell from '@/components/NotificationBell';
import { FaWhatsapp } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import RestaurantSelector from '@/components/RestaurantSelector';
import BottomNavbar from '../../BottomNavbar';
import logo from '@/assets/Logo.png';
import Demo from '@/components/Demo';

const OrdersLargeContainer = ({ children, isInStepper = false }) => {
	const { cart, setCart, handleRestaurantChange } = useOrdersContext();
	const navigate = useNavigate();
	const location = useLocation();
	const isPaymentPage = location.pathname === '/commande/paiement';
	const [isDisabled, setIsDisabled] = useState(false);
	const [runDemo, setRunDemo] = useState(false);

	const categories = cart.categories;
	const selectedCategories = categories.filter((c) => c?.is_selected);
	const currentCategoryId = categories[cart.currentStepNb]?.id;
	const currentCategory = selectedCategories.find((c) => c?.id === currentCategoryId);
	const previousSelectedCategoryIndex = selectedCategories.findIndex((c) => c.id === currentCategoryId) - 1;

	const previousCategoryIndex =
		selectedCategories.length > 0
			? categories.findIndex((c) => c?.id === selectedCategories[previousSelectedCategoryIndex]?.id)
			: cart.currentStepNb - 1;

	useEffect(() => {
		if (!currentCategory) {
			setIsDisabled(cart.menus.length !== 0);

			return;
		}

		if (currentCategory) {
			if (currentCategory.is_additional) {
				setIsDisabled(
					currentCategory.extra_products.reduce((acc, product) => acc + product.selected_quantity, 0) !== 0
				);
			} else {
				setIsDisabled(
					currentCategory.selected_products.reduce((acc, product) => acc + product.selected_quantity, 0) ===
					currentCategory.step_quantity
				);
			}

			return;
		}

		setIsDisabled(!isDisabled);
	}, [currentCategory?.selected_products, currentCategory?.extra_products, cart.menus]);

	const handleBackButton = () => {
		if (currentCategory && previousCategoryIndex < 0) {
			return navigate('/commande/menu');
		}

		setCart((prevState) => {
			return {
				...prevState,
				currentStepNb: previousCategoryIndex >= 0 ? previousCategoryIndex : -1,
			};
		});
	};

	const handleGetBackButtonText = () => {
		if ((currentCategory && previousCategoryIndex === 0) || (currentCategory && previousCategoryIndex > 0)) {
			return `Retour aux ${categories[previousCategoryIndex]?.name}`;
		}

		if (currentCategory && previousCategoryIndex < 0) {
			return 'Retour au menu';
		}

		return 'Retour en arrière';
	};

	const callContextHandleRestaurantChangeMethod = (restaurantId) => handleRestaurantChange(restaurantId);

	const handleHelpClick = () => {
		setRunDemo(true);
	};

	return (
		<>
			<Demo onClose={() => setRunDemo(false)} showHelp={runDemo} />
			<div className={`w-screen bg-cover flex items-center justify-center h-[100svh] pb-[env(safe-area-inset-bottom)] ${isPaymentPage ? 'pb-24' : ''}`}>
				<div id="orders-lc-content" className="min-h-full w-screen flex flex-col h-full">
					<div className="text-center px-4 pt-4 pb-0 md:pb-2">
						<header className="mx-auto md:landscape:pt-2 md:landscape:w-4/5 lg:w-3/5 xl:landscape:w-3/5 xl:landscape:pt-0">
							<nav className={`w-full h-full grid items-center gap-4 grid-cols-3 ${!isInStepper ? '' : 'md:landscape:grid-cols-4 xl:landscape:grid-cols-3'}`}>
								<button
									onClick={handleBackButton}
									className={`${!isInStepper ? 'hidden' : 'block'
										} transition duration-300 ease-in-out flex items-center gap-2 font-bold text-white text-sm md:text-lg hover:cursor-pointer hover:text-primary`}
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										strokeWidth={1.5}
										stroke="currentColor"
										className="w-6 h-6"
									>
										<path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
									</svg>

									{handleGetBackButtonText()}
								</button>

								<img
									onClick={() => (isDisabled || !isInStepper ? (window.location.href = '/') : null)}
									src={logo}
									alt="logo"
									className={`hover:cursor-pointer w-4/5 md:w-2/5 ${!isInStepper ? 'md:landscape:col-start-1 xl:landscape:col-start-2' : ''}`}
								/>

								<div className={`hidden md:landscape:grid ${!isInStepper ? 'md:landscape:col-start-2' : ''} xl:landscape:hidden`}>
									<RestaurantSelector onChange={callContextHandleRestaurantChangeMethod} isInline={true} />
								</div>

								<div
									className={`grid gap-2 text-white ${!isInStepper ? 'grid-cols-1 col-span-2 md:place-items-center md:col-span-2 lg:col-span-1' : ''} md:grid-cols-2`}
								>
									<button className="hidden md:block font-bold" onClick={handleHelpClick}>Besoin d'aide ?</button>
									<div className='flex place-content-end gap-2'>
										
										<NotificationBell />
										<div className="relative lg:hidden"><button className="relative" onClick={() => navigate('/me')}>
											<FaUser size={24} />
										</button></div>
									</div>
								</div>
							</nav>
						</header>
					</div>

					<div className={`text-center mb-2 ${isPaymentPage && window.innerWidth < 680 ? 'hidden' : ''} md:landscape:hidden xl:landscape:block`}>
						<RestaurantSelector onChange={callContextHandleRestaurantChangeMethod} />
					</div>

					<div className={`flex items-center justify-center w-full p-2 ${isPaymentPage ? 'pb-20' : ''}`}>
						<div className="grid grid-cols-3 gap-4 w-full md:landscape:w-[calc(100vw-2rem)] lg:w-4/5 xl:landscape:w-4/5">{children}</div>
					</div>
				</div>
			</div>

			<BottomNavbar />
		</>
	);
};

export default OrdersLargeContainer;
